import React from 'react';
import '../../main-css/shop-css/ShopPage.css';

const ShopPage = () => {
  return (
    <div className="shop-page">
      <h1 className='title'>Shop</h1>
      <div className="shop-container">
        <div className="subscription-column">
        <img src="/Images/AnimeBibleLogoTP.png" alt="Mascot" className="tier-mascot" />
          <div className="subscription-card">
            <h3>Basic Tier</h3>
            <p className="price">$5/month</p>
            <p className="description">Access to basic content.</p>
            <button className="subscribe-btn">Subscribe</button>
          </div>
        </div>

        <div className="subscription-column">
        <img src="/Images/AnimeBibleLogoTP.png" alt="Mascot" className="tier-mascot" />
          <div className="subscription-card">
            <h3>Standard Tier</h3>
            <p className="price">$10/month</p>
            <p className="description">Access to standard content + exclusive perks.</p>
            <button className="subscribe-btn">Subscribe</button>
          </div>
        </div>

        <div className="subscription-column">
        <img src="/Images/AnimeBibleLogoTP.png" alt="Mascot" className="tier-mascot" />
          <div className="subscription-card">
            <h3>Premium Tier</h3>
            <p className="price">$15/month</p>
            <p className="description">Full access to all content + VIP support.</p>
            <button className="subscribe-btn">Subscribe</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopPage;
